import { Award, BadgeCheck, BookOpen, Globe, HeartHandshake, LineChart, Network, Sparkles } from "lucide-react";

const BENEFITS = [
  { icon: BadgeCheck, title: "National Recognition", desc: "Official federation registry membership with verifiable credentials." },
  { icon: Award, title: "Certification", desc: "Federation-issued certificates for coaches, referees and officials." },
  { icon: LineChart, title: "Performance Tracking", desc: "Transparent progression and result tracking across all three disciplines." },
  { icon: BookOpen, title: "Education", desc: "Access to rulebooks, technical manuals, video library and master courses." },
  { icon: Network, title: "National Network", desc: "Direct linkage to 28 State Units and 312 District Units." },
  { icon: Globe, title: "International Pathway", desc: "Selection pipeline for ITKF, UKF and Asia/Oceania events." },
  { icon: Sparkles, title: "Technical Support", desc: "Dedicated technical committees for events, grading and disputes." },
  { icon: HeartHandshake, title: "Welfare", desc: "Scholarships, insurance support, and structured athlete welfare programmes." },
];

export default function WhyJoin() {
  return (
    <section data-testid="why-join" className="section-spacing bg-slate-50">
      <div className="nkf-container">
        <div className="max-w-3xl">
          <div className="text-[11px] uppercase tracking-[0.3em] text-nkf-red font-semibold">Why Join NKF</div>
          <h2 className="font-display text-3xl md:text-4xl text-nkf-blue mt-2 leading-tight">The Federation Advantage</h2>
          <p className="text-slate-600 mt-3">Eight reasons why coaches, athletes and academies across India choose NKF Bharat.</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mt-10 items-stretch">
          {BENEFITS.map((b) => {
            const Icon = b.icon;
            return (
              <div key={b.title} className="bg-white border border-slate-200 rounded-md p-5 federation-card hover:border-nkf-gold/60 flex flex-col h-full">
                <Icon className="h-7 w-7 text-nkf-red" />
                <h3 className="font-display text-lg text-nkf-blue mt-4">{b.title}</h3>
                <p className="text-sm text-slate-600 mt-2 leading-relaxed flex-1">{b.desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
